import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useAdminAuth } from '@/contexts/AdminAuthContext';
import { VoiceHealthSummary } from '@/components/admin/VoiceHealthSummary';
import { VoicePipelineFunnel } from '@/components/admin/VoicePipelineFunnel';
import { VoiceFailureTrends } from '@/components/admin/VoiceFailureTrends';
import { VoiceFailureTable } from '@/components/admin/VoiceFailureTable';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminHealth() {
  const { timeParams } = useAdminAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const load = useCallback(async () => {
    if (timeParams.range === 'custom' && (!timeParams.start_date || !timeParams.end_date)) { setLoading(false); return; }
    setLoading(true); setError('');
    try { const response = await axios.get(`${API}/admin/voice-health`, { params: timeParams, withCredentials: true }); setData(response.data); }
    catch (requestError) { setData(null); setError(requestError.response?.data?.detail || 'Voice health could not be loaded.'); }
    finally { setLoading(false); }
  }, [timeParams]);
  useEffect(() => { load(); }, [load]);
  if (loading && !data) return <div className="h-96 animate-pulse bg-[#EEE9E1]" data-testid="admin-health-loading" />;
  if (error) return <div className="border-l-4 border-[#D26046] bg-[#FBEDE8] p-5 text-sm text-[#8A3B27]" data-testid="admin-health-error">{error}</div>;
  if (!data) return <div className="border border-dashed border-[#CFC8BD] p-12 text-center text-sm text-[#8A8D8A]">Choose both custom dates.</div>;
  return <div className="space-y-12" data-testid="admin-health-page">{data.alerts.length > 0 && <div className="space-y-2">{data.alerts.map((alert, index) => <div className="border-l-4 border-[#D26046] bg-[#FBEDE8] p-4" key={alert.title} data-testid={`admin-health-alert-${index}`}><p className="text-sm font-semibold text-[#8A3B27]">{alert.title}</p><p className="mt-1 text-sm text-[#6B6E69]">{alert.message}</p></div>)}</div>}<VoiceHealthSummary data={data} /><VoicePipelineFunnel stages={data.stages} /><VoiceFailureTrends trends={data.trends} /><VoiceFailureTable failures={data.recent_failures} /></div>;
}
